import { baseApi } from "./baseApi";

const TEAM_BASE_URL = "/teams";

export const teamApi = baseApi.injectEndpoints({
  tagTypes: ["Team"],

  endpoints: (builder) => ({
    getTeamList: builder.query({
      query: (params) => ({ url: `${TEAM_BASE_URL}`, params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Team", _id })),
              { type: "Team", id: "LIST" },
            ]
          : [{ type: "Team", id: "LIST" }],
    }),

    getTeamDDL: builder.query({
      query: (params) => ({ url: `${TEAM_BASE_URL}/ddl`, params }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "Team", _id })),
              { type: "Team", id: "DDL" },
            ]
          : [{ type: "Team", id: "DDL" }],
    }),

    getTeamDetail: builder.query({
      query: (id) => `${TEAM_BASE_URL}/${id}`,
      providesTags: (result, error, { _id }) => [
        { type: "Team", _id },
        { type: "Team", id: "LIST" },
      ],
    }),

    createTeam: builder.mutation({
      query: (payload) => ({
        url: TEAM_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Team", id: "LIST" },
        { type: "Team", _id },
      ],
    }),

    updateTeam: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${TEAM_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Team", _id },
        { type: "Team", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetTeamListQuery,
  useLazyGetTeamListQuery,
  useGetTeamDDLQuery,
  useLazyGetTeamDDLQuery,
  useGetTeamDetailQuery,
  useCreateTeamMutation,
  useUpdateTeamMutation,
} = teamApi;
